import { ComponentsOverrides, Theme } from '@mui/material';

export const TypographyStyles: ComponentsOverrides<Theme>['MuiTypography'] = {
  root: {
    fontFamily: 'Poppins, Arial, sans-serif',
    cursor: 'default',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
};